// Shared parsing helpers for the ComputerEase license.dat text stored on
// client.permissions.celicense.

export const CLOUD_TYPE_KEYS = ["clddeltek", "cldzd", "cldzs"];

export const CLOUD_TYPE_LABELS = {
  clddeltek: "AWS Deltek Cloud",
  cldzd: "Zimcom Dedicated Cloud",
  cldzs: "Zimcom Shared Cloud",
};

export const CLOUD_TYPE_SHORT_LABELS = {
  clddeltek: "AWS",
  cldzd: "Zimcom",
  cldzs: "Zimcom",
};

// Which cloud module (if any) is enabled in the license, or null if not a cloud license.
export function parseCloudType(celicense) {
  if (!celicense) return null;
  const lines = celicense.split(/\r?\n/);
  for (const key of CLOUD_TYPE_KEYS) {
    if (lines.some((l) => l.trim() === `module=${key}`)) return key;
  }
  return null;
}

// Number of cloud logins permitted by the license (`cloudlogins=N`), or null if not specified.
export function parseCloudLogins(celicense) {
  if (!celicense) return null;
  const lines = celicense.split(/\r?\n/);
  for (const line of lines) {
    const match = line.trim().match(/^cloudlogins=(\d+)$/i);
    if (match) return parseInt(match[1], 10);
  }
  return null;
}
